import { mdsFontSizes } from "@/design-system/foundations/typography";
import { css } from "@/domains/emotion";

export const smallerIconFontSizeStyles = css({
  fontSize: mdsFontSizes().xxsmall,
  width: 12,
});
